import { EparakstsAuthorizationMethod } from 'api/core/generated';
import { AuthMethod } from 'api/core/generated';
import type { AppLanguages } from 'app-constants';

export type AvailableLanguage =
  | AppLanguages.et
  | AppLanguages.en
  | AppLanguages.lt
  | AppLanguages.lv
  | AppLanguages.ru;

export enum AppRegions {
  EE = 'EE',
  LV = 'LV',
  LT = 'LT',
}

export enum AppAuthMethod {
  ID_CARD = AuthMethod.ID_CARD,
  MOBILE = AuthMethod.MOBILE,
  PASSWORD = AuthMethod.PASSWORD,
  PAYSERA_BANKLINK = AuthMethod.PAYSERA_BANKLINK,
  SMART_ID = AuthMethod.SMART_ID,
  EPARAKSTS_MOBILE = `${AuthMethod.EPARAKSTS}_${EparakstsAuthorizationMethod.MOBILE}`,
  EPARAKSTS_SMARTCARD = `${AuthMethod.EPARAKSTS}_${EparakstsAuthorizationMethod.SMARTCARD}`,
}
